import { useState } from 'react';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import classes from 'components/CheckIn/CheckInTextField/CheckInTextField.module.scss';
import { InputAdornment, TextField } from '@material-ui/core';
import Constants from 'config/constants';
import ErrorIcon from '@material-ui/icons/Error';

export default function CheckInTextField(props) {
    const [error, setError] = useState(false);

    const textFieldTheme = createMuiTheme({
        palette: {
            primary: {
                main: "#797979"
            },
            error: {
                main: "#B80818"
            }
        },
        overrides: {
            MuiOutlinedInput: {
                root: {
                    borderRadius: 0
                }
            }
        }
    });

    const handleTextFieldChange = (event) => {
        // Replace with numeric if text field is curbside parking spot
        if (props.labels === Constants.CHECK_IN_CURBSIDE_PARKING_SPOT_TEXTFIELD_LABELS) {
            props.setValue(event.target.value.replace(/[^0-9]/gi, ''));
        } else {
            props.setValue(event.target.value);
        }
        event.target.value ? setError(false) : setError(true);
    }

    return (
        <ThemeProvider theme={textFieldTheme}>
            <TextField data-test-id="check-in-text-field"
                       className={classes.TextField}
                       variant="outlined"
                       inputProps={{
                           style: error ? {fontSize: 16, color: "#B80818"} : {fontSize: 16},
                           maxLength: Constants.TEXT_CHAR_LIMIT
                       }}
                       InputLabelProps={{style: {fontSize: 11}}}
                       label={props.labels.label}
                       placeholder={props.labels.placeholder}
                       value={props.value}
                       onChange={handleTextFieldChange}
                       error={error}
                       helperText={error ? props.labels.errorHelperText : (props.value && `${props.value.length}/${Constants.TEXT_CHAR_LIMIT}`)}
                       FormHelperTextProps={{style: {fontSize: 11}}}
                       InputProps={error && {
                           endAdornment: (
                               <InputAdornment position="start">
                                   <ErrorIcon style={{color: "#B80818"}} fontSize="large"/>
                               </InputAdornment>
                           ),
                       }}
                       type={props.labels === Constants.CHECK_IN_CURBSIDE_PARKING_SPOT_TEXTFIELD_LABELS ? 'tel' : 'text'}/>
        </ThemeProvider>
    );
};
